import React from 'react';

const AcademicLinks = () => {
    return (
        <div className="flex flex-col space-y-1">
            <a href="http://orcid.org/0000-0003-1600-0227" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                <i className="ai ai-orcid ai-2x"></i>
                <span className="ml-2">0000-0003-1600-0227</span>
            </a>
            {/* <a href="https://www.cienciavitae.pt/portal/FA11-8E2D-DC05" 
            className="text-gray-600 hover:text-gray-800 flex items-center">
            <i className="ai ai-ciencia-vitae ai-2x"></i>
            <span className="ml-2">FA11-8E2D-DC05</span>
            </a> */}
            {/*<a href="https://scholar.google.com/citations?user=HfAkCRMAAAAJ&hl=en" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                <i className="ai ai-google-scholar ai-2x"></i>
                <span className="ml-2">N. Datia</span>
            </a>
            <a href="https://www.researchgate.net/profile/Nuno-Datia" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
                <i className="ai ai-researchgate ai-2x"></i>
            
            </a>
            <a href="https://www.linkedin.com/in/nunodatia/" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300">
            <i className="fa fa-linkedin"></i>
            
            </a>*/}
            <div >
                <a href="https://scholar.google.com/citations?user=HfAkCRMAAAAJ&hl=en" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300" style={{marginRight : 10}}>
                <i className="ai ai-google-scholar ai-2x"></i> 
                </a>
                <span className="text-blue-600 dark:text-blue-400 ai-2x">|</span>
                <a href="https://www.researchgate.net/profile/Nuno-Datia" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300" style={{margin : 10}}>
                <i className="ai ai-researchgate ai-2x"></i>
                </a>
                <span className="text-blue-600 dark:text-blue-400 ai-2x">|</span>
                <a href="https://www.linkedin.com/in/nunodatia/" className="text-blue-600 dark:text-blue-400 hover:text-blue-800 dark:hover:text-blue-300" style={{margin : 10}}>
                <i className="fa fa-linkedin ai-2x"></i>
            
                </a>
            </div>
            {/* <a href="https://www.scopus.com/authid/detail.uri?authorId=16550896700" className="text-gray-600 hover:text-gray-800 flex items-center">
            <i className="ai ai-scopus ai-2x"></i>
            <span className="ml-2">16550896700</span>
            </a> 
            <a href="https://www.webofscience.com/wos/author/record/AAM-8381-2020" className="text-gray-600 hover:text-gray-800 flex items-center">
            <i className="ai ai-researcherid ai-2x"></i>
            <span className="ml-2">AAM-8381-2020</span>
            </a>
            <a href="http://pt.linkedin.com/in/matildepato" className="text-gray-600 hover:text-gray-800 flex items-center">
            <i className="fa fa-linkedin ai-2x"></i>
            <span className="ml-2">Matilde</span>
            </a>*/}
        </div>
    );
};

export default AcademicLinks;